<div class="entities" >
  <div *ngFor="let label of labels" class="entity">
    <app-chip [entityType]="label"></app-chip>
  </div>
</div>
